import { LocalizedDatePipe } from './shared/localized-date.pipe';
import { ServiceNotfoundComponent } from './core/navigation/service-notfound/service-notfound.component';
import { PaymentSuccessComponent } from './core/form-transaction/payment-success/payment-success.component';
import { PaymentFailureComponent } from './core/form-transaction/payment-failure/payment-failure.component';
import { LocalizedPipe } from './shared/localized.pipe';
import { EmailVerificationReminderComponent } from './core/account/email-verification-reminder.component';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TenantModule } from './tenant/tenant.module';
import { MemberNavigationComponent } from './core/navigation/member-navigation/member-navigation.component';
import { LoginComponent } from './core/account/login/login.component';
import { HomeComponent } from './core/home/home.component';
import { FormsModule } from '@angular/forms';
import { AuthService } from './core/account/auth.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptorService } from './core/account/auth-interceptor.service';
import { SignupComponent } from './core/account/signup/signup.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ActivationComponent } from './core/account/activation/activation.component';
import { ResetPasswordComponent } from './core/account/reset-password/reset-password.component';
import { ResetRequestComponent } from './core/account/reset-request/reset-request.component';
import { SharedModule } from './shared/shared.module';
import { BrowserModule } from '@angular/platform-browser';
import { MyProfileComponent } from './core/my-profile/my-profile.component';
import { NotfoundComponent } from './core/navigation/notfound/notfound.component';
import { UnauthorizedComponent } from './core/navigation/unauthorized/unauthorized.component';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DupesComponent } from './core/notifications/dupes/dupes.component';
import { InvitationsComponent } from './core/notifications/invitations/invitations.component';
import { GroupsComponent } from './core/groups/groups.component';
import { FormTransactionComponent } from './core/form-transaction/form-transaction.component';
import { FormsComponent } from './core/forms/forms.component';
import { ViewMembersComponent } from './core/groups/view-members/view-members.component';
import { MyTasksComponent } from './core/my-tasks/my-tasks.component';
import { MyDonationsComponent } from './core/my-donations/my-donations.component';
import { FastCheckinComponent } from './core/fast-checkin/fast-checkin.component';
import { MyStatementComponent } from './core/my-statement/my-statement.component';
import { QrSelfCheckinComponent } from './core/qr-self-checkin/qr-self-checkin.component';
import { QrSelfCheckinFixedComponent } from './core/qr-self-checkin-fixed/qr-self-checkin-fixed.component';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';
// import { MessagingService } from './shared/services/messaging.service';
import { AsyncPipe } from '@angular/common';
import { APP_BASE_HREF } from '@angular/common';
import { SelectTenantComponent } from './core/select-tenant/select-tenant.component';
import { SwitchTenantComponent } from './core/switch-tenant/switch-tenant.component';
import { PushNotificationsComponent } from './core/push-notifications/push-notifications.component';
import { CommonModule } from '@angular/common';
import { LoadingSpinnerComponent } from './shared/loading-spinner/loading-spinner.component';
import { ProfileComponent } from './shared/profile/profile/profile.component';
import { QrSelfCheckinGroupComponent } from './core/qr-self-checkin-group/qr-self-checkin-group.component';
import { QrSelfCheckinVenueComponent } from './core/qr-self-checkin-venue/qr-self-checkin-venue.component';

@NgModule({ declarations: [ServiceNotfoundComponent, PaymentSuccessComponent, PaymentFailureComponent,
        AppComponent,
        MemberNavigationComponent,
        LoginComponent,
        HomeComponent,
        SignupComponent,
        ActivationComponent,
        ResetPasswordComponent,
        ResetRequestComponent,
        MyProfileComponent,
        NotfoundComponent,
        UnauthorizedComponent,
        DupesComponent,
        InvitationsComponent,
        GroupsComponent,
        FormTransactionComponent,
        FormsComponent,
        ViewMembersComponent,
        MyTasksComponent,
        MyDonationsComponent,
        FastCheckinComponent,
        QrSelfCheckinComponent,
        QrSelfCheckinFixedComponent,
        QrSelfCheckinGroupComponent,
        QrSelfCheckinVenueComponent,
        MyStatementComponent,
        SelectTenantComponent,
        SwitchTenantComponent,
        PushNotificationsComponent
    ],
    bootstrap: [AppComponent],
    imports: [LocalizedDatePipe, LocalizedPipe, EmailVerificationReminderComponent, AppRoutingModule,
        TenantModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        BrowserModule,
        NgbCollapseModule,
        FormsModule,
        CommonModule,
        ServiceWorkerModule.register('sw.js', {
            enabled: environment.production,
            registrationStrategy: 'registerImmediately',
            updateViaCache: 'none',
        }),
        BrowserAnimationsModule],
        providers: [
        // MessagingService,
        AsyncPipe,
        AuthService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorService,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideAuth(() => getAuth()),
        provideMessaging(() => getMessaging()),
    ] })
export class AppModule {}
